import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AccountData, RefundablePaymentData } from '../api';
import { useAuth } from '../session/InternalAuthProvider';
import { getDateFormat } from '../common/getDateAndTimeFormat';
import { RefundIconButton } from './RefundIconButton';
import { formatRefundCardSuffix, formatRefundDate, useRefundAmountFormatter } from './refundFormat';

type PaymentRefundRowProps = {
  item?: RefundablePaymentData;
  onRefund: (item: RefundablePaymentData) => void;
};

export const PaymentRefundRow = ({ item, onRefund }: PaymentRefundRowProps) => {
  const { t } = useTranslation();
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const formatAmount = useRefundAmountFormatter();

  if (!item) {
    return null;
  }

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      flexWrap="nowrap"
      gap={1}
      borderRadius="8px"
      border="1px solid"
      borderColor="divider"
      p={1.5}>
      <Grid container flexDirection="column">
        <Typography fontWeight={600}>{t('refunds.voucherPayment.title')}</Typography>
        <Typography variant="caption" color="text.secondary">
          {t('refunds.voucherPayment.line', {
            amount: formatAmount(item.amount ?? 0),
            suffix: formatRefundCardSuffix(item.card_suffix),
            date: formatRefundDate(item.paid_at, getDateFormat(account).longDateFormat),
          })}
        </Typography>
      </Grid>
      <RefundIconButton item={item} onRefund={onRefund} />
    </Grid>
  );
};
